<template>
    <v-container>
        <br>
        <h2>Lector código QR</h2>
        <br>

        <div justify="center" align="center" style="height:76vh">
            <p class="warning">{{ error }}</p>
            <p>{{ permitirCamara }}</p>

            <p class="decode-result"><b>{{ result }}</b></p>

            <qrcode-stream class="lector-qr" @decode="onDecode" @init="onInit" >
                <div class="lector-qr-btn">
                    <v-btn color="#ffc068" dark v-on:click="irRestaurante()">Ver carta</v-btn>
                </div>
            </qrcode-stream>
            <br>
        </div>

    </v-container>
</template>

<script>
    import { QrcodeStream } from 'vue-qrcode-reader'
    import store from '@/store/index';
    
    export default {
      name: 'LectorQR',
      data: () => ({
        result: '',
        error: '',
        slug: '',
        permitirCamara: '',
      }),
      components: { 
          QrcodeStream 
        },
      methods: {         
        irRestaurante () {
          window.location.href = this.result;
        },
        onDecode (result) {
          this.result = result

          if(result.search("lacartaweb") == '-1') {
            // Extranjero
            confirm("Esta carta no pertenece a 'LaCartaWeb' y por tanto procederá a salir de la plataforma. Desde este momento dejará de disfrutar de la carta digital más avanzada del mercado. Sabemos que nos echarás de menos y nosotros a ti... Esperamos volver a verte pronto. ¡Buen provecho!")
            window.location.href = result;

            /*
            this.$store.commit("cambiarCiudadID", '');
            this.$store.commit("cambiarCiudadSlug", '');
            this.$store.commit("cambiarComercioID", '');
            this.$store.commit("cambiarComercioSlug", '');
            this.$store.commit("cambiarTipo", "LectorQRExt");
            this.$store.commit("cambiarLectorQRExt", result);

            console.log(this.$store.state.LectorQRExt)
            console.log(this.$store.state.tipoElegido)
            */

            
          
          } else {
            // LaCartaWeb
            window.location.href = result;
          }
        },

        async onInit (promise) {
          try {
            await promise
          } catch (error) {
            if (error.name === 'NotAllowedError') {
              this.error = "Error: Debe dar permisos a la cámara para capturar códigos QR"
              this.permitirCamara = 
              "PASOS PARA ACTIVAR CÁMARA: 1. Pulse en 'Configuración'. 2. Ahora pulse en 'Configuración del sitio web'. 3. Pulse en 'Cámara' y en Permitir"



            } else if (error.name === 'NotFoundError') {
              this.error = "Error: No se ha encontrado cámara en este dispositivo"
            } else if (error.name === 'NotSupportedError') {
              this.error = "Error: Conexión segura requerida (HTTPS, localhost)"
            } else if (error.name === 'NotReadableError') {
              this.error = "Error: ¿Está la cámara en uso en otra aplicación?"
            } else if (error.name === 'OverconstrainedError') {
              this.error = "Error: Cámara no soportada"
            } else if (error.name === 'StreamApiNotSupportedError') {
              this.error = "Error: Lector no soportado para este navegador. Recomendamos usar Google Chrome o Firefox"
            }
          }
        }
      }
    }
</script>

<style scoped>
.lector-qr {
  width: 300px;
  height: 300px;
  border: 1px solid grey;
}
.lector-qr-btn{
  position: absolute;
  bottom: 10px;
  right: 10px;
}
</style>